import { AuthService } from '@app/shared/common/IDSVRAuthProviders/auth.service';
import { Injectable } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { XmlHttpRequestHelper } from '@shared/helpers/XmlHttpRequestHelper';
import * as moment from 'moment';
import { HttpMethodBaseService } from './HttpMethodsBase/httpmethods-base';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class QuoteStatusService {

    readonly API_BASE_URL_IDP = abp.setting.values['PortalSettings.authority'];

    constructor(
        private _authService: AuthService,
        private httpMethodBaseService: HttpMethodBaseService
    ) {}

    updateQuoteStatus(
        quoteGuids: Array<string>,
        brokerGuid: string,
        status: number,
        isApproved: boolean = false,
        coverReason: string | null = null,
        businessAssuranceType: string | null = null,
        policyHolderIsInsuredLife: string | null = null,
        primaryQuoteGuid: string | null = null,
        lifeInsuredId: string | null = null,
        initialQuircStatus: string | null = null,
        wasInitiallyReferred: boolean | null = null
    ) {
        let customHeaders = {
            [abp.multiTenancy.tenantIdCookieName]: abp.multiTenancy.getTenantIdCookie(),
            'Authorization': 'Bearer ' + abp.auth.getToken()
        };

        let data = {
            'quoteGuids' : quoteGuids,
            'status' : status,
            'timeStamp' : moment(),
            'isApproved' : isApproved,
            'accessToken': this._authService.user.access_token,
            'brokerGuid': brokerGuid,
            'coverReason': coverReason,
            'businessAssuranceType': businessAssuranceType,
            'policyHolderIsInsuredLife': policyHolderIsInsuredLife,
            'currentUserGuid': this._authService.user.profile.sub,
            'primaryQuoteGuid': primaryQuoteGuid,
            'lifeInsuredid': lifeInsuredId,
            'initialQuircStatus': initialQuircStatus,
            'wasInitiallyReferred': wasInitiallyReferred,
        };

        XmlHttpRequestHelper.ajax(
            'PUT',
            AppConsts.remoteServiceBaseUrl + '/api/services/app/QuoteStatus/UpdateQuoteStatus',
            customHeaders,
            JSON.stringify(data),
            result => {
                console.log('updateQuoteStatus', result);
            }
        );
    }

    pushMessages(quoteGuids: Array<string>, brokerGuid: string, status: number, isApproved: boolean = false,
        coverReason: string | null = null, businessAssuranceType: string | null = null, policyHolderIsInsuredLife: string | null = null): void {
        let data = {
            'quoteGuids' : quoteGuids,
            'status' : status,
            'timeStamp' : moment(),
            'isApproved' : isApproved,
            'accessToken': this._authService.user.access_token,
            'brokerGuid': brokerGuid,
            'coverReason': coverReason,
            'businessAssuranceType': businessAssuranceType,
            'policyHolderIsInsuredLife': policyHolderIsInsuredLife,
            };

        this.httpMethodBaseService.post<any>(AppConsts.remoteServiceBaseUrl + '/api/services/app/QuoteStatus/PushMessages', JSON.stringify(data), new HttpHeaders({'Content-Type': 'application/json'}))
        .pipe((res => {
            return res;
        })).subscribe(result => {});
    }
}
